import type {ControlOption} from 'shells/card/segmented-control';

import type {ChatSettingsOfflineFormTypeEnum as OfflineFormType} from 'nutshell-graphql-types';

import {FORM_TYPE_CONVERSATIONAL, FORM_TYPE_REGULAR, FORM_TYPE_NONE} from '../../consts';

export const BUTTON_OPTIONS: ControlOption<OfflineFormType>[] = [
    {
        type: 'small',
        title: 'Ask visitors to fill out a form',
        value: FORM_TYPE_REGULAR,
    },
    {
        type: 'small',
        title: 'Intake visitor info from chat',
        value: FORM_TYPE_CONVERSATIONAL,
    },
    {
        type: 'small',
        title: 'Hide Nutshell Chat',
        value: FORM_TYPE_NONE,
    },
];
